import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// import styles from './Header.module.scss'

const Header = ({
    logo,
    children,
    bgColour,
    openNavImg,
    closedNavImg,
}) => {
    const [mainMenu, setMainMenu] = useState()
    const [openMenu, setOpenMenu] = useState()
    const [closeMenu, setCloseMenu] = useState()
    const [navElement, setNavElement] = useState()

    useEffect(() => {
        setMainMenu(document.querySelector('.mainMenu'))
        setCloseMenu(document.querySelector('.closeMenu'))
        setNavElement(document.querySelector('ul'))
        setOpenMenu(document.querySelector('.openMenu'))

        function onScroll() {
            const currentScrollPos = window.pageYOffset
            if (currentScrollPos > 1000) {
                document.getElementById('navbar').style.top = '-250px'
            } else {
                document.getElementById('navbar').style.top = '0'
            }
        }
        window.addEventListener('scroll', onScroll)
        return function unMount() {
            window.removeEventListener('scroll', onScroll)
        }
    }, [])

    function show() {
        mainMenu.style.display = 'flex'
        mainMenu.style.top = '0'
    }
    function close() {
        mainMenu.style.top = '-100%'
    }

    // eslint-disable-next-line no-unused-expressions
    openMenu?.addEventListener('click', show)
    // eslint-disable-next-line no-unused-expressions
    closeMenu?.addEventListener('click', close)
    // eslint-disable-next-line no-unused-expressions
    navElement?.addEventListener('click', close)

    return (
        <header className="header" id="navbar">
            <nav>
                <div className="logo">{logo ? <img src={logo} alt="NFT Logo" /> : <h1>project:metaverse [foresight]</h1>}</div>
                <div className="openMenu">
                    <img
                        src={openNavImg}
                        alt="open menu"
                        width="100%"
                        height="auto"
                    />
                </div>
                <ul className="mainMenu">
                    {children}
                    <div className="closeMenu">
                        <img
                            src={closedNavImg}
                            alt="close menu"
                            width="100%"
                            height="auto"
                        />
                    </div>
                </ul>
            </nav>
        </header>
    )
}

Header.propTypes = {
    logo: PropTypes.string.isRequired,
    closedNavImg: PropTypes.string.isRequired,
    openNavImg: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Header
